export default "__VITE_ASSET__3264f56a__"